<template>
<MainNav />
<router-view :key="$route.fullPath"></router-view>
</template>

<script>
import MainNav from './components/MainNav.vue'
export default {
  name: 'App',
  components: { MainNav }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}
html, body {
  min-height: 100vh;
}
</style>
